import resetItemSavedStatus from "../../../common/actions/resetItemSavedStatus";
import updateItemIntent from "./updateItemIntent";
import updateItemSuccess from "./updateItemSuccess";

const updateSharedBoardItem = (dispatch, item) => {
  dispatch(resetItemSavedStatus(item));
  dispatch(updateItemIntent(item));
  dispatch(updateItemSuccess(item));
};

export default updateSharedBoardItem;
